import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import Logo from '../common/Logo';
import * as FiIcons from 'react-icons/fi';

const { FiYoutube, FiLinkedin, FiTwitter } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-brand-darker/95 border-t-2 border-brand-electric/20 pt-20 pb-10 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-brand-neon/5 to-transparent pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand Col */}
          <div className="col-span-1">
            <Link to="/">
              <Logo size="default" />
            </Link>
            <p className="text-white/70 text-sm mb-6 mt-4">
              Turn any video into a complete course. Automatically.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-brand-electric/70 hover:text-brand-electric transition-colors">
                <SafeIcon icon={FiYoutube} className="text-xl"/>
              </a>
              <a href="#" className="text-brand-electric/70 hover:text-brand-electric transition-colors">
                <SafeIcon icon={FiLinkedin} className="text-xl"/>
              </a>
              <a href="#" className="text-brand-electric/70 hover:text-brand-electric transition-colors">
                <SafeIcon icon={FiTwitter} className="text-xl"/>
              </a>
            </div>
          </div>

          {/* Product Col */}
          <div>
            <h4 className="font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-3">
              <li><Link to="/features" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Features</Link></li>
              <li><Link to="/pricing" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Pricing</Link></li>
              <li><Link to="/use-cases/course-creators" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Use Cases</Link></li>
              <li><Link to="#" className="text-white/60 hover:text-brand-electric text-sm transition-colors">API Docs</Link></li>
              <li><Link to="#" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Changelog</Link></li>
            </ul>
          </div>

          {/* Resources Col */}
          <div>
            <h4 className="font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/blog" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Blog</Link></li>
              <li><Link to="#" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Help Center</Link></li>
              <li><Link to="#" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Video Tutorials</Link></li>
              <li><Link to="#" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Testimonials</Link></li>
            </ul>
          </div>

          {/* Company Col */}
          <div>
            <h4 className="font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-white/60 hover:text-brand-electric text-sm transition-colors">About</Link></li>
              <li><Link to="#" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Careers</Link></li>
              <li><Link to="/contact" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Contact</Link></li>
              <li><Link to="#" className="text-white/60 hover:text-brand-electric text-sm transition-colors">Affiliate Program</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t-2 border-brand-electric/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm">© 2026 VidRevive. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="text-white/50 hover:text-brand-electric text-sm transition-colors">Privacy Policy</Link>
            <Link to="#" className="text-white/50 hover:text-brand-electric text-sm transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;